// removed by extract-text-webpack-plugin
module.exports = {"MainTitle":"MainTitle__MainTitle__1WqLO","TitleTextNormal":"MainTitle__TitleTextNormal__dGjPe","TitleTextMIY":"MainTitle__TitleTextMIY__1XHl-","TitleTextMaybe":"MainTitle__TitleTextMaybe__3Q5CD","TitleTextSubText":"MainTitle__TitleTextSubText__2tCwX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainTitle/MainTitle.css
// module id = 589
// module chunks = 0